import React, {Component} from 'react'
import {GatsbyImage, getImage} from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import Link from '../utils/link'
import CtaArrow1 from '../assets/images/cta-arrow.png'
import CtaArrow2 from '../assets/images/cta-arrow-2.png'
import CtaArrow3 from '../assets/images/cta-arrow-3.png'


class Cta extends Component {

  render() {

    let {image, title, button, backgroundColour} = this.props

    let buttonColor;

    switch (backgroundColour) {
      case 'blue':
      case 'green':
        buttonColor = 'mauve';
        break;
      case 'mauve':
        buttonColor = 'blue';
        break;
      default:
    }

    return (
      <section className={`cta cta--${backgroundColour}`}>
        <div className='cta__image'>
          {image?.localFile && <GatsbyImage loading='lazy' image={getImage(image?.localFile)} alt={title}/>}
        </div>
        <div className='cta__inner'>
          <div className='cta__content'>
            {title && <h3>{parse(title)}</h3>}
            {button?.url &&
              <Link to={button.url} className={`btn btn--${buttonColor}`}>{button.title}</Link>
            }
          </div>
          <div className='cta__arrow'>
            {backgroundColour === 'blue' && <img src={CtaArrow3} alt="arrow"/>}
            {backgroundColour === 'green' && <img src={CtaArrow1} alt="arrow"/>}
            {backgroundColour === 'mauve' && <img src={CtaArrow2} alt="arrow"/>}
          </div>
        </div>
      </section>
    )
  }
}

export default Cta